// @flow
import React from 'react';

import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import H1 from '@waglabs/h1';
import H2 from '@waglabs/h2';
import Image from '@waglabs/image';
import Span from '@waglabs/span';

import { BodyContainer } from '../../../BodyContainer';
import { WagTagDescription } from '../WagTagDescription';

import WagTagLogo from './assets/wag-tag-logo.svg';
import WagTagLogoRight from './assets/wag-tag-logo-right.png';
import BackgroundDesktopImage from './assets/background-desktop.png';
import BackgroundIpadImage from './assets/background-ipad.png';
import BackgroundMobileImage from './assets/background-mobile.png';


export const WagTagHeading = () => (
  <Box
    bg={['white', 'backgroundGray']}
    position="relative"
  >
    <Box
      backgroundImage={[
        `url(${BackgroundMobileImage})`,
        `url(${BackgroundIpadImage})`,
        `url(${BackgroundDesktopImage})`,
      ]}
      backgroundSize="cover"
      backgroundPosition="center"
      minHeight={['380px', '500px', '755px']}
      zIndex={0}
    />

    <Flex
      alignContent="center"
      width={1}
      position="absolute"
      top={0}
    >
      <BodyContainer>
        <Box
          width={1}
          zIndex={1}

        >
          <Flex
            flexDirection="column"
            py={4}
            width={1}
            position="relative"
          >
            <Box
              px={3}
            >
              <Box
                mb={3}
              >
                <Image
                  src={WagTagLogo}
                  width={['75px', '145px']}
                />
              </Box>

              <H1
                display="none"
              >
                Wag! Tag
              </H1>
              <H2
                color="white"
                fontFamily="bodyMuli"
                fontWeight="bold"
                fontSize={[7, 8, '42px']}
              >
                Give your dog a
                <Span
                  display="block"
                >
                  smarter way home.
                </Span>
              </H2>

              <Box
                display={['none', 'block']}
                mt="24px"
                mb={2}
                maxWidth={['350px', '350px', '450px']}
              >
                <WagTagDescription
                  color="white"
                  fontSize={4}
                />
              </Box>
              <Flex
                justifyContent="flex-end"
                mt={[3, '-50px', 5]}
              >
                <Image
                  src={WagTagLogoRight}
                  cursor="pointer"
                  height={['135px', '210px', '280px']}
                />
              </Flex>
            </Box>
          </Flex>
        </Box>
      </BodyContainer>
    </Flex>
  </Box>
);
